import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgCalendarDate = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M7.02 2a.75.75 0 0 1 .75.75v2.096h6.365a.75.75 0 0 1 0 1.5H7.769v2.096a.75.75 0 1 1-1.5 0V2.75A.75.75 0 0 1 7.02 2M4.172 4.846A2.173 2.173 0 0 0 2 7.02v12.808A2.173 2.173 0 0 0 4.173 22h15.654A2.173 2.173 0 0 0 22 19.827V7.019a2.173 2.173 0 0 0-2.173-2.173H17.73V2.75a.75.75 0 1 0-1.5 0v5.692a.75.75 0 0 0 1.5 0V6.346h2.096a.673.673 0 0 1 .673.673v12.808a.673.673 0 0 1-.673.673H4.173a.673.673 0 0 1-.673-.673V7.019a.673.673 0 0 1 .673-.673.75.75 0 0 0 0-1.5m9.212 6.443a.75.75 0 0 1 .75-.75h1.423a.75.75 0 0 1 .75.75v5.653h.673a.75.75 0 0 1 0 1.5h-2.846a.75.75 0 0 1 0-1.5h.673V12.04h-.673a.75.75 0 0 1-.75-.75m-6.366-.75a.75.75 0 0 0 0 1.5h2.058l-1.235 1.646a.75.75 0 0 0 .598 1.2h.01q.015 0 .048.002a3 3 0 0 1 .775.137c.435.145.554.32.554.534a1 1 0 0 0 .007.103 1.143 1.143 0 0 1-1.289 1.289 1 1 0 0 0-.103-.008H7.02a.75.75 0 1 0 0 1.5h1.376a2.644 2.644 0 0 0 2.931-2.937c-.026-1.156-.93-1.682-1.553-1.895l1.404-1.871a.75.75 0 0 0-.6-1.2zm1.422 4.346"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgCalendarDate;
